import { sendFreshchatEventToGA4 } from "@shared/Analytics/ecommerce/voice/voice-analytics";

type FreshchatEventDetails = {
  action: "open" | "close";
};

/*
  We have no event to detect when the form har been submited 
  but when someone has submited the first form the form is set to visibility:hidden
*/
const checkWhenSubmitButtonIsClicked = (() => {
  let observer: MutationObserver | null = null;

  const start = () => {
    observer = new MutationObserver(() => {
      // it is some timeout between the second form is added and the firstone is sett to hidden.
      setTimeout(() => {
        const chatInput = document.querySelector(".chat-fc-form-outer");
        if (!chatInput) return;

        const visibility = window.getComputedStyle(chatInput).visibility;
        if (visibility === "hidden") {
          sendFreshchatEventToGA4("chatbot-start");
          stop();
        }
      }, 50);
    });

    observer.observe(document.body, { childList: true, subtree: true });
  };

  const stop = () => {
    observer?.disconnect();
    observer = null;
  };

  return { start, stop };
})();

const freshChatTracking = (event: CustomEvent<FreshchatEventDetails>) => {
  const { action } = event.detail;
  if (action === "open") {
    sendFreshchatEventToGA4("chatbot-open");
    checkWhenSubmitButtonIsClicked.start();
  } else {
    sendFreshchatEventToGA4("chatbot-close");
    checkWhenSubmitButtonIsClicked.stop();
  }
};

export const bootstrapFreshChatTracking = () => {
  window.addEventListener("ice-freshchat-changed", (e) => {
    freshChatTracking(e as CustomEvent<FreshchatEventDetails>);
  });
};
